import { CBadge } from '@coreui/react-pro'
import React from 'react'

const StatusBadgeRenderer = (
  interviewStatus: string,
  isVendor: boolean,
): JSX.Element => {
  // For vendors, show 'OFFERED' for these statuses
  const vendorRestrictedStatuses = [
    'JOINED',
    'OFFERED',
    'DID_NOT_JOIN',
    'OFFER_CANCELLED',
    'joined',
  ]

  if (isVendor && vendorRestrictedStatuses.includes(interviewStatus)) {
    return (
      <CBadge className="rounded-pill text-white" color="success">
        OFFERED
      </CBadge>
    )
  }

  switch (interviewStatus) {
    case 'NEW':
    case 'REPROCESS':
      return (
        <CBadge className="rounded-pill text-white btn-primary">
          {interviewStatus}
        </CBadge>
      )
    case 'IN_PROCESS':
      return (
        <CBadge className="rounded-pill sh-badge-light">{'IN PROGRESS'}</CBadge> // very weird but yes frontend it should always display 'IN PROGRESS' instead of 'IN PROCESS'
      )
    case 'RESCHEDULED':
      return (
        <CBadge className="rounded-pill sh-badge-light">
          {interviewStatus?.replace(/_/g, ' ')}
        </CBadge>
      )
    case 'HOLD':
    case 'CANCEL':
      return (
        <CBadge className="rounded-pill text-white" color="warning">
          {interviewStatus}
        </CBadge>
      )
    case 'REJECTED':
    case 'NO_SHOW':
    case 'DID_NOT_JOIN':
    case 'OFFER_CANCELLED':
      return (
        <CBadge className="rounded-pill text-white" color="danger">
          {interviewStatus?.replace(/_/g, ' ')}
        </CBadge>
      )
    case 'OFFERED':
    case 'COMPLETED':
    case 'JOINED':
      return (
        <CBadge className="rounded-pill text-white" color="success">
          {interviewStatus}
        </CBadge>
      )
    case 'L1_SHORTLISTED':
      return (
        <CBadge className="rounded-pill btn-primary text-white">
          {'L1-SHORTLISTED'}
        </CBadge>
      )
    case 'L2_SHORTLISTED':
      return (
        <CBadge className="rounded-pill btn-primary text-white">
          {'L2-SHORTLISTED'}
        </CBadge>
      )
    case 'L3_SHORTLISTED':
      return (
        <CBadge className="rounded-pill btn-primary text-white">
          {'L3-SHORTLISTED'}
        </CBadge>
      )
    case 'L4_SHORTLISTED':
      return (
        <CBadge className="rounded-pill btn-primary text-white">
          {'L4-SHORTLISTED'}
        </CBadge>
      )
    case 'L5_SHORTLISTED':
      return (
        <CBadge className="rounded-pill btn-primary text-white">
          {'L5-SHORTLISTED'}
        </CBadge>
      )
    case 'L6_SHORTLISTED':
      return (
        <CBadge className="rounded-pill btn-primary text-white">
          {'L6-SHORTLISTED'}
        </CBadge>
      )
    default:
      return <></>
  }
}

export default StatusBadgeRenderer
